import { render } from "./CoolButton.vue?vue&type=template&id=69b2e071&scoped=true"
import script from "./CoolButton.vue?vue&type=script&lang=js"
export * from "./CoolButton.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-69b2e071"

export default script